export const noteTypes = Object.freeze({
    plainText: 0,
    soap: 1
});